import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../AppDialog/AppDialog";
import { DefaultButton } from "../../../button/defaultButton/DefaultButton";
import { DefaultTextareaField } from "../../../forms/inputs/textareaField/DefaultTextareaField";
import { InputError } from "../../../forms/inputs/inputError/InputError";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { IGoalsDataSource } from "../../models/goalModels";
import { GoalDialogMode } from "../../hooks/useGoalsOverview";
import { useGoalTextDialog } from "../../hooks/useGoalTextDialog";
import styles from "./GoalTextDialog.module.scss";

interface IGoalTextDialogProps {
  mode: GoalDialogMode | null;
  dataSource: IGoalsDataSource;
  onHide: () => void;
}

/** Adds a goal or a sub-goal, or edits one's text. */
export const GoalTextDialog = ({ mode, dataSource, onHide }: IGoalTextDialogProps) => {
  const { form, header, parentText, errorMessage, isLoading, handleSubmit } = useGoalTextDialog({
    mode,
    dataSource,
    onHide,
  });

  return (
    <AppDialog
      header={header}
      visible={!!mode}
      onHide={onHide}
      className={styles.root}
      dismissableMask={false}
    >
      <FormProvider {...form}>
        <form className={styles.root_form} onSubmit={handleSubmit} noValidate>
          <RenderWhen condition={!!parentText}>
            <p className={styles.root_parent}>
              Към целта: <span>{parentText}</span>
            </p>
          </RenderWhen>

          <DefaultTextareaField
            name="text"
            label="Текст"
            placeholder="Напр. Фаза 1 или Да направя 10 клека"
            rows={3}
            required
            width="100%"
          />

          <RenderWhen condition={!!errorMessage}>
            <InputError message={errorMessage} />
          </RenderWhen>

          <DefaultButton label="Запази" type="submit" loading={isLoading} width="100%" />
        </form>
      </FormProvider>
    </AppDialog>
  );
};
